module.exports = __webpack_public_path__ + "media/images/apple-8f3676c408886ac995462f5dc673cdfe.jpg";